export default "__VITE_ASSET__yabbzXBV__"